import { connect } from 'react-redux';
import Blockies from 'react-blockies';
import Img from 'react-image';
import PropTypes from 'prop-types';
import React from 'react';
import { fromJS } from 'immutable';

import dhid from '../../../dhid';
import { getUsers } from '../../../ducks/crew/users';
import Link from '../../../components/Link';

const propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.number,
  seed: PropTypes.string,
  users: PropTypes.shape({
    get: PropTypes.func,
  }),
  dispatch: PropTypes.func,
  clickable: PropTypes.bool,
};

const defaultProps = {
  clickable: true,
};

class UserImage extends React.Component {
  componentDidMount() {
    const { dispatch, id } = this.props;
    if (id !== dhid.getUserID()) {
      dispatch(getUsers(id));
    }
  }

  render() {
    const {
      id, seed, users, className, size, clickable,
    } = this.props;

    const user = id === dhid.getUserID() ? fromJS(dhid.getUser()) : users.get(id);
    const format = size <= 64 ? 'square64' : 'square160';
    const url = user && user.getIn(['avatar', format]);

    const blockiesSeed = (user && user.get('id')) || seed;
    const blockie = () => (blockiesSeed ? (
      <Blockies
        className={className}
        seed={blockiesSeed}
        color="#ff6600"
        bgColor="#1e1e20"
        size={8}
        scale={size / 8}
      />
    ) : (
      <div
        className={className}
        style={{ width: size, height: size }}
      />
    ));

    const image = (
      url
        && (
        <Img
          className={className}
          src={url}
          loader={<div style={{ width: size, height: size }} />}
          unloader={blockie()}
          style={{ width: size, height: size }}
        />
        )
    ) || blockie();

    return clickable && user ? <Link to={'/crew/users/'.concat(user.get('id'))}>{image}</Link> : image;
  }
}

UserImage.propTypes = propTypes;
UserImage.defaultProps = defaultProps;

function mapStateToProps(state) {
  return {
    users: state.getIn(['crewUsers', 'list']),
  };
}

export default connect(mapStateToProps)(UserImage);
